<template>
  <div class="card-container"
    @click="openDrawer(terminal)">
    <div style="display: flex; align-items: center;">
      <div class="card-img">
            <img style="padding: 10px;"
            :src="terminal.img? terminal.img :require('@/assets/imgs/svgs/logo-default.svg')"
            alt="logo">
            <div :class="terminal.active ? 'active-indicator' : 'inactive-indicator' "></div>
        </div>
        <div class="card-info">
            <span class="title-card">
                {{terminal.name}}
            </span>
            <span>{{terminal.description}}</span>
        </div>
    </div>
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"/>
      </template>
      <v-list>
        <v-list-item  title="Editar" link
        @click="editPos(terminal)"/>
        <v-list-item  :title="terminal.active ? 'Bloquear' : 'Reactivar' " link
        @click="openDialogActive()"/>
        <v-list-item  title="Eliminar" link
        @click="openDialogDelete()"/>
      </v-list>
    </v-menu>
  </div>
  <add-edit-terminals ref="addEditModal" @refreshList="refresh"/>
  <pos-drawer ref="drawerPos" @openEditPos="editPos"/>

  <diaog-two-options
    ref="activeDialog"
    @okBtn="activePos(terminal)"
    :title="terminal.active ?  'Bloquear punto de venta': 'Reactivar punto de venta' "
    :txtBtn="terminal.active ? 'Sí, bloquear' : 'Sí, reactivar' "
    :txtBold="terminal.name"
    txtOne="Colaboradores asignados a "
    :txtTwo="terminal.active
    ? ' no podrán usar la plataforma. ¿Deseas continuar?'
    : ' podrán usar nuevamente Commercia. ¿Deseas continuar?' "/>

  <diaog-two-options
    ref="deleteDialog"
    @okBtn="deletePos(terminal)"
    title="Eliminar punto de venta"
    txtBtn="Sí, Eliminar"
    :txtBold="terminal.name"
    txtOne="¿Deseas eliminar"
    txtTwo="? No podrás deshacer la acción."/>

</template>
<script>
import AddEditTerminals from '@/components/forms/AddEditTerminals.vue'
import PosDrawer from '@/components/drawers/TerminalsDrawer.vue'
import DiaogTwoOptions from '@/components/dialogs/DiaogTwoOptions.vue'
import terminalApi from '@/api/terminalsApi'
export default {
  name: 'CommerciaVuePosCard',
  emits: ['refreshList'],
  components: {
    AddEditTerminals,
    PosDrawer,
    DiaogTwoOptions
  },
  props: {
    terminal: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      business: this.$store.getters.business
    }
  },
  methods: {
    editPos (pos) {
      this.$refs.addEditModal.edit(pos)
    },
    async activePos (pos) {
      if (await terminalApi.changeActive(pos)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    async deletePos (pos) {
      if (await terminalApi.delete(pos)) {
        this.$emit('refreshList')
      } else {
        console.log('Cambio Fallido')
      }
    },
    openDrawer (pos) {
      this.$refs.drawerPos.show(pos)
    },
    openDialogActive () {
      this.$refs.activeDialog.open()
    },
    openDialogDelete () {
      this.$refs.deleteDialog.open()
    },
    refresh () {
      this.$emit('refreshList')
    }
  }

}
</script>
<style scoped>
    @import '@/assets/styles/cards.css';
</style>
